import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircleIcon } from 'lucide-react';
export function CardMonitoringPrograms() {
  const navigate = useNavigate();
  return <div className="max-w-5xl mx-auto" data-id="element-4912">
      <h1 className="text-3xl font-bold text-gray-900 mb-3" data-id="element-4913">
        Card monitoring programs
      </h1>
      <p className="text-gray-700 mb-2" data-id="element-4914">
        Card networks require that you keep dispute and fraud at acceptable
        levels. If your business exceeds the limits dictated by the networks
        (e.g., Visa or Mastercard) you're placed into one of their monitoring
        programs.{' '}
        <a href="#" className="text-blue-600 hover:text-blue-700 underline" data-id="element-4915">
          Learn more
        </a>
      </p>

      <div className="mt-8" data-id="element-4916">
        <button onClick={() => navigate('/card-monitoring/vamp')} className="w-full bg-white border border-gray-200 rounded-lg p-6 hover:border-blue-300 hover:shadow-sm transition-all text-left group" data-id="element-4917">
          <h2 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors" data-id="element-4918">
            Visa Acquirer Monitoring Program (VAMP)
          </h2>
          <div className="flex items-center gap-2 text-green-600" data-id="element-4919">
            <CheckCircleIcon size={20} data-id="element-4920" />
            <span className="text-sm font-medium" data-id="element-4921">In good standing</span>
          </div>
        </button>
      </div>
    </div>;
}